import { Gem, ShieldCheck, Wrench, HeartHandshake } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const CHAPTERS = [
  { no: "01", icon: Gem, title: "Zanaat", text: "Her saat, mağazamıza ulaşmadan önce titizlikle seçilir. Bizim için saat bir aksesuar değil, bir zanaat eseridir." },
  { no: "02", icon: ShieldCheck, title: "Orijinallik Garantisi", text: "Sattığımız her ürün %100 orijinaldir; garanti belgesi ve sertifikasıyla, özel kutusunda teslim edilir." },
  { no: "03", icon: Wrench, title: "Uzman Teknik Servis", text: "Pil değişiminden kapsamlı bakıma — satış sonrasında da yanınızdayız. Saatiniz bize emanet." },
  { no: "04", icon: HeartHandshake, title: "Müşteri Sadakati", text: "2006'dan beri aynı özen: nesilden nesile güvenle tercih edilen bir aile işletmesiyiz." },
];

export const Manifesto = () => (
  <section
    id="neden-atilmaz"
    data-testid="trust-manifesto-section"
    className="relative py-16 md:py-24 lg:py-32 bg-sand overflow-hidden"
  >
    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-emerald/20 to-transparent" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <SectionHeading
          eyebrow="Neden Atılmaz Saat"
          title={<>Güven & <span className="italic text-emerald">Zanaat</span> Manifestosu</>}
          testId="manifesto"
        />
      </div>

      <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.no} delay={i * 0.1}>
            <div className="group relative border-t border-emerald/15 pt-6" data-testid={`manifesto-chapter-${c.no}`}>
              <div className="flex items-start justify-between">
                <span className="font-serif text-5xl font-semibold text-emerald/10 leading-none">
                  {c.no}
                </span>
                <c.icon size={22} strokeWidth={1.5} className="text-emerald mt-2" />
              </div>
              <h3 className="mt-5 font-serif text-xl sm:text-2xl font-semibold text-ink">{c.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-sage">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <blockquote className="mt-16 md:mt-20 max-w-3xl">
          <p className="font-serif text-2xl sm:text-3xl lg:text-4xl font-medium italic leading-snug text-emerald">
            "Bir saat yalnızca zamanı göstermez; ona verdiğiniz değeri anlatır."
          </p>
          <footer className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-sage">
            — Atılmaz Ailesi
          </footer>
        </blockquote>
      </Reveal>
    </div>
  </section>
);
